/*Questo modulo si occupa di recuperare le impostazione relative al duo del gateway*/
import Vue from "vue";
import {
  DuoService,
} from "@/common/api.service";

const initialState = {
  features: null,//posti esterni / attuazione / etc
  units: null,//unità abitative / multi utenza
  invitations: [],//inviti in sospeso delle unita abitative
  users: [], //utenti associati alle unita abitative
  settings: null,
  loading: false,
};

export const state = { ...initialState };

export const actions = {
  async fetchDuo(context) {
    context.commit("setLoading", true);
    console.log("Fetching duo settings...")
    const { data } = await DuoService.get();
    context.commit("setUnits", data.duo.units);
    context.commit("setFeatures", data.duo.features);
    context.commit("setLoading", false);
    return data;
  },
  async features(context) {
    context.commit("setLoading", true);
    console.log("Fetching duo features settings...")
    const { data } = await DuoService.get('features');
    context.commit("setFeatures", data);
    context.commit("setLoading", false);
    return data;
  },
  async units(context) {
    context.commit("setLoading", true);
    console.log("Fetching duo units settings...")
    const { data } = await DuoService.get('units');
    context.commit("setUnits", data);
    context.commit("setLoading", false);
    return data;
  },
  async settings(context) {
    context.commit("setLoading", true);
    console.log("Fetching duo general settings...")
    const { data } = await DuoService.get('settings');
    context.commit("setSettings", data);
    context.commit("setLoading", false);
    return data;
  },
  async users(context, flat_uuid) {
    console.log("Fetching duo users of flat " + flat_uuid + " ...")
    const { data } = await DuoService.get('flat/' + flat_uuid + '/users');
    context.commit("setUnitUsers", {uuid: flat_uuid, users: data});
    return data;
  },
  async invitations(context, flat_uuid) {
    console.log("Fetching duo invitations of flat " + flat_uuid + " ...")
    const { data } = await DuoService.get('flat/' + flat_uuid + '/invitations');
    context.commit("setUnitInvitations", {uuid: flat_uuid, invitations: data});
    return data;
  },
  async addUnit(context, unit) {
    await DuoService.addUnit(unit);
    //context.dispatch('fetchDuo');
    context.dispatch('units');
  },
  async saveSettings(context, settings) {
    await DuoService.saveSettings(settings);
    //context.dispatch('fetchDuo');
  },
  async updateUnit(context, data) {
    await DuoService.updateUnit(data);
    //context.dispatch('fetchDuo');
    context.dispatch('units');
  },
  async removeUnit(context, unit) {
    await DuoService.removeUnit(unit);
    //context.dispatch('fetchDuo');
    context.dispatch('units');
  },
  async flatInvite(context, payload) {
    await DuoService.flatInvite(payload);
    context.dispatch('invitations');
  },
  async removeInvitation(context, invite) {
    await DuoService.removeInvitation(invite);
    context.dispatch('invitations');
  },
  async removeUser(context, user) {
    await DuoService.removeUser(user);
    context.dispatch('users');
  },
  async saveFeatures(context, payload) {
    await DuoService.saveFeatures(payload);
    context.commit('setFeatures', payload);
  }
};


export const mutations = {
  setUnits(state, data) {
    state.units = data;
    for (let key in state.units) {
      console.log(state.units[key]);
      state.units[key].active = undefined;
      state.units[key].invitations = undefined;
      state.units[key].users = undefined;
    }
    console.log('New units: ', data);
  },
  setFeatures(state, data) {
    state.features = data;
    console.log('New features: ', data);
  },
  setSettings(state, data) {
    state.settings = data;
    console.log('New settings: ', data);
  },
  setLoading(state, data) {
    state.loading = data;
  },
  addUnit(state, unit) {
    state.units.push(unit);
  },
  setUnitInvitations(state, data) {
    console.log(data);
    //state.units[data.uuid].invitations = data.invitations;
    //Vue.set(state.units[data.uuid], 'invitations', data.invitations);
    //state.invitations[data.uuid] = data.invitations;
    Vue.set(state.invitations, data.uuid, data.invitations);
    console.log('Invitations are: ', state.invitations[data.uuid]);
  },
  setUnitUsers(state, data) {
    console.log(data);
    //state.units[data.uuid].users = data.users;
    //Vue.set(state.units[data.uuid], 'users', data.users);
    //state.users[data.uuid] = data.users;
    Vue.set(state.users, data.uuid, data.users);
    console.log(state.users);
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
